import { Component, Input, OnInit } from '@angular/core';
import { TableType } from 'src/shared/enums';
import importTableFields from 'src/app/models/import-table/fields';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditUsesPopupComponent, IUseLabelEditData } from './edit-uses-popup/edit-uses-popup.component';
import { CalibrationUsesLabelModel } from '../../../models';
import { ConfirmationDialogComponent } from '../../../../shared/zoneiqui/components';
import { CommonService } from '../../../../shared/services/common.service';
import { getUseTypeByName } from '../../../../shared/enums/uses.type.enum';
import { ImportService } from 'src/app/core/services/import.service';
import IUseClass = ZoneIQCalibration.IUseClass;
import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import * as _ from 'lodash';
import { CalibrationUsesLabelsMap } from 'src/app/interfaces/calibration-uses-labels-map';
import { ZoningCodeService } from 'src/app/core/services';

@Component({
    standalone: false,
    selector: 'data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']

})
export class UsesDataTableComponent implements OnInit {
    @Input()
    table: CalibrationUsesLabelsMap;

    @Input()
    tableType: TableType;

    @Input()
    zoningCodeId: number;

    activeLabelIndex: number;
    activeGlobal: string;
    activeUse: ICalibrationUsesLabel;
    originalUse: ICalibrationUsesLabel;
    useClassOptions: IUseClass[] = [];

    get tableFields() {
        return importTableFields[this.tableType];
    }

    get tableNames() {
        return this.table
            ? Object.keys(this.table)
                  .filter(x => !!x)
                  .sort(this.globalSorting)
            : [];
    }

    constructor(
        private readonly dialog: MatDialog,
        private commonService: CommonService,
        private importService: ImportService,
        private zcService: ZoningCodeService
    ) {}

    ngOnInit() {
        this.useClassOptions = this.zcService.useClasses;
    }

    globalSorting(a: string, b: string) {
        return getUseTypeByName(a) - getUseTypeByName(b);
    }

    isSelectedUses(use: ICalibrationUsesLabel): boolean {
        return use === this.activeUse;
    }

    editUses(i: number, usesTypeName: string, use: ICalibrationUsesLabel) {
        const usesType = this.zcService.selectedZoningCode.CalibrationUsesTypes.find(ut => ut.Name === usesTypeName);
        const data: IUseLabelEditData = {
            index: i,
            usesType,
            tables: this.table,
            zoningCodeId: this.zoningCodeId,
            use
        };
        this.dialog.open(EditUsesPopupComponent, {
            height: '400px',
            width: '500px',
            data
        });
    }

    sortingUses() {
        this.table[this.activeGlobal].sort(CalibrationUsesLabelModel.sortingUsesLabel);
    }

    get isValidLabelName() {
        return this.activeUse && this.commonService.checkEmptyString(this.activeUse.Label);
    }

    blurHandler(_target) {
        if (this.isValidLabelName) {
            this.saveUsesModification();
        } else if (this.activeGlobal) {
            this.setOriginValue();
        } else {
            return;
        }
    }

    setActiveUses(index: number, globalName: string, use: ICalibrationUsesLabel) {
        if (!this.commonService.checkEmptyString(use.Label) || this.activeUse === use) {
            return;
        }
        this.activeUse = use;
        this.originalUse = _.pick(use, ['Label', 'ClassId']);

        this.activeLabelIndex = index;
        this.activeGlobal = globalName;
        this.sortingUses();
    }

    saveUsesModification() {
        if (!this.activeUse) {
            return;
        }
        const cleanValue = this.activeUse.Label.trim();
        if (cleanValue.length > 1) {
            this.activeUse.Label = cleanValue;
            this.sortingUses();

            this.importService.validateUsesLabels();
            this.clearSelection();
        }
    }

    cancelUsesEdit() {
        this.setOriginValue();
    }

    setOriginValue() {
        Object.assign(this.activeUse, this.originalUse);
        this.clearSelection();
    }

    deleteUses(index: number, globalName: string) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '30%';
        dialogConfig.data = {
            title: 'Delete Use',
            topContent: `Current use will be deleted. Continue?`
        };
        const deleteUseRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        deleteUseRef.afterClosed().subscribe(needToDelete => {
            if (!needToDelete) {
                return;
            }
            this.table[globalName].splice(index, 1);
            if (!this.table[globalName].length) {
                delete this.table[globalName];
            }
            this.importService.validateUsesLabels();
        });
    }

    clearSelection() {
        this.activeLabelIndex = null;
        this.activeGlobal = null;
        this.activeUse = null;
    }

    getUseClassLabel(use: ICalibrationUsesLabel) {
        if (!use) {
            return;
        }
        return _.get(
            this.useClassOptions.find(useClass => useClass.Id === use.ClassId),
            'Label'
        );
    }
}
